// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1hhkX","sendOtp":"AuthorizeToLogin_sendOtp__1XnUo"};